import React, { useRef } from "react";
import { splitKeys } from "../../../features/smallFunction/SmallFunctions";

const CustomLegend = (props) => {
  const {
    payload,
    align,
    verticalAlign,
    layout,
    containerHeight,
    containerWidth,
    valueKeys,
    legendFontColor,
    isLegendBold,
  } = props;

  const containerRef = useRef(null);
  // console.log(isLegendBold);

  const itemsOverflow =
    layout === "vertical" ? "overflow-y-auto" : "overflow-x-auto";
  const itemsTextTruncate =
    layout === "vertical" ? "overflow-hidden" : "overflow-x-hidden";
  const itemsAlignment = layout === "vertical" ? "flex-col" : "flex-row ";
  const displayFlex =
    layout === "vertical"
      ? "flex-col overflow-y-auto"
      : "  overflow-x-auto gap-2";

  const horizontalPosition =
    layout === "horizontal"
      ? align === "center"
        ? "justify-center"
        : align === "left"
          ? "justify-start"
          : "justify-end"
      : "";

  if (!Array.isArray(payload)) {
    return null;
  }

  const visibleLegendData = payload.slice(0, payload.length); // or payload.slice(currentIndex, currentIndex + payload.length)
  const legendData = visibleLegendData.map((item, index) => {
    // console.log(item);

    let { color, value, name } = item;

    if (valueKeys && valueKeys.length === 1) {
      value = splitKeys(value);
    }
    // console.log(value);

    return (
      <div
        key={index}
        className="flex items-center"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "2px", // Padding for spacing

          boxSizing: "border-box", // Include padding and border in width
          // width: itemWidth,
        }}
      >
        {/* Color rectangle */}
        <div
          style={{
            backgroundColor: color,
            width: "24px",
            height: "12px",
            marginRight: "4px", // Space between rectangle and text
            display: "inline-block",
          }}
        />

        <p
          className={`whitespace-nowrap ${itemsTextTruncate}  text-ellipsis ${isLegendBold ? "font-bold" : ""
            }`}
          style={{ color: legendFontColor }}
        >
          {name} {value}
        </p>
      </div>
    );
  });
  // console.log(visibleLegendData);
  // console.log(legendData);

  return (
    <div
      className={`flex items-center  ${horizontalPosition} gap-1`}
      style={{ maxWidth: containerWidth, align: "right" }}
    >
      {/* Conditionally render icons based on layout */}
      {layout === "vertical" ? null : (
        <div>{/* Your icon or component here for horizontal layout */}</div>
      )}

      <div
        ref={containerRef}
        className={`flex ${displayFlex} items-left    max-w-full  custom-scrollbar`}
        style={
          layout === "vertical"
            ? { maxHeight: containerHeight, height: "auto" }
            : {}
        }
      >
        {legendData}
      </div>

      {layout === "vertical" ? null : <div></div>}
    </div>
  );
  // return (<div className="w-full text-left">
  //     <p>Mohit</p>
  // </div>)
};

export { CustomLegend };
